import { getStoryblokApi } from "@storyblok/react";
import { logger } from '@/lib/logger';

export const BASE_PATH = "marketing/target-defense";
logger.log('NEXT_PUBLIC_NODE_ENV:', process.env.NEXT_PUBLIC_NODE_ENV);
export const version = process.env.NEXT_PUBLIC_NODE_ENV === "development" ? "draft" : "published";
logger.log('Storyblok version:', version);
// export const version = "published";

/**
 * Get the initialized Storyblok API client
 */
export function getClient() {
  return getStoryblokApi();
}
